import React, { useState } from "react";
// import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import c1 from "../../Assets/images/c1.jpg";
// import kit from "../../Assets/images/kit.jpg";
// import wa from "../../Assets/images/wa.jpg";
// import jwe from "../../Assets/images/jwel.jpg";
// import head from "../../Assets/images/head.jpg";
// import shoo from "../../Assets/images/shoo.jpg";
// import lip from "../../Assets/images/lip.jpg";
// import sar from "../../Assets/images/sar.jpg";
// import sar1 from "../../Assets/images/sar1.jpg";
// import sar2 from "../../Assets/images/sar2.jpg";
// import dr from "../../Assets/images/dr.jpg";
// import dr1 from "../../Assets/images/dr1.jpg";
// import dr2 from "../../Assets/images/dr2.jpg";
// import men from "../../Assets/images/men.jpg";
// import men1 from "../../Assets/images/men1.jpg";
// import men2 from "../../Assets/images/men3.jpg";
// import f from "../../Assets/images/f.jpg";
// import f1 from "../../Assets/images/f1.jpg";
// import f2 from "../../Assets/images/f2.jpg";
// import mf from "../../Assets/images/mf.jpg";
// import mf1 from "../../Assets/images/mf1.jpg";
// import mf2 from "../../Assets/images/mf2.jpg";
// import ear from "../../Assets/images/ear.jpg";
// import kt from "../../Assets/images/kt.jpg";
// import kt1 from "../../Assets/images/kt1.jpg";
// import kt2 from "../../Assets/images/kt2.jpg";
// import lip1 from "../../Assets/images/lip1.jpg";
// import l from "../../Assets/images/l.jpg";
// import mk from "../../Assets/images/mk.jpg";
// import ap from "../../Assets/images/Apparel.svg";
// import be from "../../Assets/images/Beauty.svg";
// import fr from "../../Assets/images/Furniture.svg";
// import home from "../../Assets/images/Home.svg";
// import ele from "../../Assets/images/Electronics.svg";
// import Shoes from "../../Assets/images/Shoes.svg";
import { ArrowBack } from "@mui/icons-material";
import { useQuery } from "react-query";
import { categoriesFn } from "../../Services/Home/Categories";
import { CircularProgress } from "@mui/material";
import { subCategoriesFn } from "../../Services/Home/SubCategories";
import { useNavigate } from "react-router-dom";

const Categories = () => {
  const [value, setValue] = React.useState(0);
  const [categoryId, setCategoryId] = useState(null);

  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { data: categories, isLoading } = useQuery(
    ["categories"],
    () => categoriesFn(),
    {
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );
  const { data: subCategories, isLoading: isLoadingSubCategories } = useQuery(
    ["subCategories", categoryId, categories],
    () =>
      categories &&
      subCategoriesFn({
        category_id: categoryId
          ? categoryId
          : categories?.data?.data?.main_category_list?.[0]?.id,
      }),
    {
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  return (
    <div className="flex flex-col w-full">
      <div className="fixed shadow z-50 top-0 w-full">
        <div className="p-4 flex gap-5 bg-white dark:bg-zinc-900">
          <ArrowBack size="large" onClick={() => navigate(-1)} />
          <p className="text-xl">Categories</p>
        </div>
      </div>
      {isLoading ? (
        <div className="h-screen flex justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        <Box className="flex pt-[62px] !bg-zinc-100 dark:!bg-zinc-700">
          <Tabs
            orientation="vertical"
            value={value}
            onChange={handleChange}
            className="category w-36"
            sx={{
              borderRight: 1,
              borderColor: "divider",
            }}
          >
            {categories?.data?.data?.main_category_list?.map(
              (category, index) => {
                return (
                  <Tab
                    key={index + 1}
                    className="!capitalize"
                    onClick={() => setCategoryId(category.id)}
                    label={
                      <div className="flex flex-col gap-1 justify-center items-center">
                        <img
                          src={
                            category.image !== "null"
                              ? category.image
                              : "https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/category.jpg"
                          }
                          alt=""
                          className="w-12 h-12 rounded-full"
                        />
                        <p>{category.category} </p>
                      </div>
                    }
                  />
                );
              }
            )}
          </Tabs>

          <div className="!p-3 !h-[87vh] pb-10 w-full hide-scroll !overflow-y-auto">
            <div className="flex flex-col bg-white dark:bg-zinc-900 p-3 rounded-xl shadow">
              {isLoadingSubCategories ? (
                <div className="flex justify-center items-center min-h-[80px]">
                  <CircularProgress />
                </div>
              ) : (
                <div className="gap-2 grid grid-cols-3 min-h-[80px]">
                  {subCategories?.data?.data?.map((item, index) => {
                    return (
                      <div
                        key={index + 1}
                        className="flex flex-col gap-2 justify-center items-center"
                        onClick={() =>
                          navigate("/category", {
                            state: {
                              from: "subCategory",
                              categoryId: item.id,
                              categoryName: item.subcategory,
                            },
                          })
                        }
                      >
                        <img
                          src={
                            item.image
                              ? item.image
                              : "https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/PhoneVersion/category.jpg"
                          }
                          alt=""
                          className="h-12 w-12 rounded-full"
                        />
                        <p className="text-xs w-16 text-center overflow-hidden whitespace-nowrap text-ellipsis">
                          {item.subcategory}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </Box>
      )}
    </div>
  );
};

export default Categories;
